<template>
    <div v-if="open_cases && (closed_casesTable.data.length>0)" class="container">
        <h2>Active cases</h2>
        
        <div class="case-list">
            <router-link tag="div" v-for="open_case in open_cases" :to="'/cases/' + open_case.caseid" :key="open_case.caseid" :class="{'attention' : ((open_case.status == 'client_waiting') || (open_case.status == 'hold' && open_case.assignee == $store.state.account.id))}">
                <div>
                    <h3>#{{open_case.caseid}}</h3>
                    <p>{{baseToText(open_case.subject)}}</p>
                    <div class="pill xl green" v-if="open_case.status == 'agent_waiting'">Awating customer</div>
                    <div class="pill xl red" v-if="open_case.status == 'hold'">Awaiting specific supporter</div>
                    <div class="pill xl" v-if="open_case.status == 'closed'">Closed</div>
                    <div class="pill xl red" v-if="open_case.status == 'client_waiting'">Awating supporter</div>
                    <div class="pill xl" v-if="open_case.status == 'archived'">Archived</div>
                    <div class="pill xl green" v-if="open_case.status == 'active'">Active</div>
                </div>
                <div>
                    <router-link tag="div" :to="'/customers/' + open_case.user">
                        <p>User</p>
                        <span>{{open_case.userinfo.name}}</span>
                    </router-link>
                    <div class="no-click">
                        <p>Updated</p>
                        <span>{{dateTimeFormat(open_case.updated)}}</span>
                    </div>
                    <div class="no-click">
                        <p>Created</p>
                        <span>{{dateTimeFormat(open_case.creation)}}</span>
                    </div>
                    <router-link tag="div" :to="'/customers/' + open_case.assignee" :class="{'no-click' : (!open_case.assignee)}">
                        <p>Assignee</p>
                        <span v-if="open_case.assignee">{{open_case.assigneeinfo.name}}</span>
                        <span v-else>No assignee</span>
                    </router-link>
                    <div class="no-click">
                        <p>Department</p>
                        <span v-if="open_case.title != null">{{open_case.title}}</span>
                        <span v-else>No department</span>
                    </div>
                    <router-link tag="div" :to="'/products/' + open_case.product" :class="{'no-click' : (!open_case.product)}">
                        <p>Product</p>
                        <span v-if="open_case.product">{{open_case.product}}</span>
                        <span v-else>No product</span>
                    </router-link>
                </div>
            </router-link>
            <p class="no-result" v-if="open_cases.length == 0">No active caces found</p>
        </div>

        <h2>Archived Cases</h2>
        <vue-table-dynamic class="tableModifier" 
        :params="closed_casesTable" 
        @row-click="clickCaseTable"
        ref="table"
        >
        </vue-table-dynamic>
    </div>
    <Loading v-else/>
</template>
<style scoped lang="scss">
.case-list{
    display: flex;
    flex-direction: column;
    &>div{
        width: 100%;
        padding: 2rem;
        border-radius: 5px;
        background-color: var(--bg-color-2);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        margin-bottom: 1rem;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
        transition: box-shadow 300ms ease, background-color 300ms ease;
        &:hover{
            background-color: var(--bg-color-3);
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
        }
        &.attention{
            background-image: linear-gradient(45deg, #b71c1c, #f44336);
            position: relative;
            &:before{
                content: " ";
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                background-color: white;
                transition: opacity 300ms ease;
                opacity: 0;
                z-index: 0;
            }
            &:hover:before{
                opacity: 0.08;
            }
            &>*{
                z-index: 2;
            }
            background-size: 200% 200%;
            animation: animation 2s infinite;
            order: -1;
            color: white;
            @keyframes animation{
                0%{
                    background-position: 0% 0%;
                }
                25%{
                    background-position: 100% 0%;
                }
                50%{
                    background-position: 100% 100%;
                }
                75%{
                    background-position: 0% 100%;
                }
            }
        }
        display: flex;
        &>div{
            &:first-child{
                width: 280px;
                flex-shrink: 0;
                flex-grow: 0;
                display: flex;
                flex-direction: column;
                h3{
                    margin-bottom: 0.8rem;
                }
                p{
                    margin: 0 0 1.5rem 0;
                }
                .pill{
                    margin: 0;

                }
            }
            &:last-child{
                flex-grow: 2;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                margin: -1.5rem -0.5rem;
                &>div{
                    flex-grow: 0;
                    margin: 0.5rem;
                    padding: 1rem 1.5rem;
                    border-radius: 5px;
                    transition: box-shadow 300ms ease, background-color 300ms ease;
                    height: max-content;
                    &:not(.no-click):hover{
                        background-color: rgba(gray, 0.3);
                        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
                    }
                    p{
                        margin: 0 0 5px 0;
                        font-weight: bold;
                    }
                    span{
                        margin: 0;
                        display: block;
                        font-size: 0.9rem;
                        opacity: 0.9;
                    }
                    cursor: pointer;
                    .no-click{
                        cursor: default;
                        pointer-events: none;
                    }
                }
            }
        }
        @media(max-width: 800px){
            flex-direction: column;
            &>div{
                &:first-child{
                    width: 100%;
                    margin-bottom: 2rem;
                }
            }
        }
    }
    &:not(:last-child){
        margin-bottom: 3rem;
    }
}
</style>
<script>
import VueTableDynamic from 'vue-table-dynamic'
import Loading from '@/components/parts/Loading.vue'
export default {
    name: 'Cases',
    components: { VueTableDynamic, Loading },
    data() {
        return {
            open_cases: [],
            closed_casesTable: {
                data: [],
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 15,
                pageSizes: [],
                sort: [0,2,3,4,5],
                maxWidth:2000,
            },
            tablehead: [['Case ID','Subject','Department','Status','Created at','Last Update at']],
        }
    },
    methods: {
        baseToText(base){
            return atob(base);
        },
        clickCaseTable(index, data){
            if(data[0]!='Case ID'){
                this.$router.push('/cases/'+data[0]);
            }
        },
        getCasesData: function(){
            var vue = this;
            this.$socket.client.emit('getAchievedCases',null, (error, response) => {
                if(error=='200'){
                    vue.closed_casesTable.data = vue.tablehead.concat(response.map(data => [data.caseid,atob(data.subject),data.title,data.status,data.creation,data.updated]));
                }
            })
            this.$socket.client.emit('getActiveCases',null, (error, response) => {
                if(error=='200'){
                    vue.open_cases = response;
                }
            })
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        }
    },
    mounted() {
        this.getCasesData();
    },
}
</script>